/* tslint:disable */
/* eslint-disable */
export enum WorkVoucherBookingModeEnum {
  Simple = 'simple',
  Projects = 'projects',
  Order = 'order'
}
